import { render, staticRenderFns } from "./2021-10-1.vue?vue&type=template&id=a7deb1bc&scoped=true&"
import script from "./2021-10-1.vue?vue&type=script&lang=ts&"
export * from "./2021-10-1.vue?vue&type=script&lang=ts&"
import style0 from "./2021-10-1.vue?vue&type=style&index=0&id=a7deb1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7deb1bc",
  null
  
)

export default component.exports